/**
 * /admin/preferences/interface — Interface section of Preferences.
 *
 * Theme/Density/Keyboard groups. All controls write localStorage immediately (D1).
 * No Save button — only Reset (D1). ThemeMode changes bridge to ThemeProvider.
 */
import { createFileRoute } from '@tanstack/react-router';
import { InterfaceSection } from '../../../components/preferences/InterfaceSection';

export const Route = createFileRoute('/_admin/preferences/interface')({
  component: InterfacePage,
});

function InterfacePage() {
  return <InterfaceSection />;
}
